import { cookieStorage } from './storage';

const MGM_COOKIE_NAME = 'nu__mgm_parameters';

export const persistMGMParameters = (options = { }) => {
  const {
    cookieName = MGM_COOKIE_NAME,
    storage = cookieStorage,
    currentTimestamp = Date.now(),
  } = options;

  return parameters => {
    const hasIdInParams = parameters.id;

    if (hasIdInParams) {
      const TEN_YEARS_FROM_NOW = new Date().getFullYear() + 10;
      const expiresInTenYears = new Date(new Date().setYear(TEN_YEARS_FROM_NOW));

      const mgmValues = {
        id: parameters.id,
        timestamp: currentTimestamp,
      };

      storage.set(cookieName, mgmValues, expiresInTenYears);
    }
  };
};

export const getMGMParameters = ({
  storage = cookieStorage,
  cookieName = MGM_COOKIE_NAME,
} = {}) => storage.get(cookieName);

export const getPersistedMGMID = (
  mgmParameters = getMGMParameters(),
  currentTimestamp = Date.now(),
) => {
  if (!mgmParameters || !mgmParameters.id || !mgmParameters.timestamp) {
    return null;
  }

  /*
  * We are disabling the timespan feature due to a risk problem as soon as
  * the problem is solved, we should enable this feature again.
  */
  const mgmTimespan = mgmParameters.timestamp;
  const isMGMValid = currentTimestamp <= mgmTimespan;
  const hasPastMGMInvite = mgmParameters.id && isMGMValid;

  return hasPastMGMInvite ? mgmParameters.id : null;
};

export const getMGMToETL = ({
  persistedMGM = getMGMParameters(),
  hasReferralIdOnURL = false,
}) => {
  const hasMGMId = Boolean(persistedMGM && persistedMGM.id);

  if (hasReferralIdOnURL || !hasMGMId) {
    return {};
  }

  return {
    mgmPersisted: true,
    persistedMGMId: persistedMGM.id,
    persistedAt: new Date(persistedMGM.timestamp).toISOString(),
  };
};
